export {
    CollapsibleContent,
    type CollapsibleContentProps,
} from "./CollapsibleContent";
